export const DEFAULT_API_BASE_URL = 'https://web-production-a0ce2.up.railway.app';

export const API_BASE_URL = process.env.REACT_APP_API_URL || DEFAULT_API_BASE_URL;

// Cloudflare Turnstile site key for anonymous public-chat verification.
// Leave unset to skip the challenge (the backend also skips verification
// when TURNSTILE_SECRET_KEY is unset — configure both together).
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';
